import { useState, useEffect, useMemo } from 'react';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../../_virtual/moment.js';
import '../../../chat_context.js';
import { useChatApi } from '../../../hooks/use_chat_api.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';

const useServicesChatShortcuts = (isActive) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const api = useChatApi();
    useEffect(() => {
        if (!isActive)
            return;
        setLoading(true);
        api.services
            .get("chat", { fields: { Chat: "teams_i_lead" } })
            .then(({ teams_i_lead }) => {
            const data = teams_i_lead.map(({ value, service_type_name, team_name }) => ({
                service_type: {
                    id: value.service_type_id,
                    name: service_type_name,
                },
                team: {
                    id: value.team_id,
                    name: team_name,
                },
            }));
            setData(data);
        })
            .finally(() => setLoading(false));
    }, [isActive]);
    const serviceTypeTeams = useMemo(() => {
        return data.reduce((acc, { service_type, team }) => {
            let serviceTypeEntry = acc.find((entry) => entry.id === service_type.id);
            if (!serviceTypeEntry) {
                serviceTypeEntry = {
                    id: service_type.id,
                    name: service_type.name,
                    teams: [],
                };
                acc.push(serviceTypeEntry);
            }
            serviceTypeEntry.teams.push(team);
            return acc;
        }, []);
    }, [data]);
    return { loading, serviceTypeTeams };
};

export { useServicesChatShortcuts };
//# sourceMappingURL=use_services_chat_shortcuts.js.map
